<template>
  <div style="background: #fff;">
    <el-tabs v-model="activeName" style="line-height: 38px;" >
      <el-tab-pane label="我要评论" class="vct_text" name="first">
        <div class="vc_wypl">
          <div class="vcw_textarea"><textarea v-model="commentValue" placeholder="我来说两句...(最多200字符)" maxlength="200"  id="TextArea1" @keyup="checkLength();"></textarea></div>
          <div class="vcw_btn">
            <p class="vcw_btn_num">您还可以输入：<span id="sy">{{curr}}</span>字</p>
            <el-tooltip content="请勿发表政治性言论，请勿谈论色情、暴力等内容的话题。严禁任何反动言论和宣传;" placement="top" effect="light">
              <el-button @click="commitComment" type="primary" :disabled="!commentValue">发表评论</el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="vc_title">
          <div class="vct_text">全部评论<span>（{{total}}）</span></div>
        </div>
        <div class="vc_plList">
          <div class="vcpl" v-for="item in commentList">
            <div class="vcpl_pic"><img :src="item.userInfo.image"/></div>
            <div class="vcpl_info">
              <div class="vcpli_user"><span class="vcpli_user_name">{{item.userInfo.realName}}</span><span
                class="vcpli_user_time">{{item.createTime}}</span></div>
              <div class="vcpli_text">
                {{item.content}}
              </div>
              <div class="vcpli_disk" v-show="item.adminReplay !=''">
                <div class="vcdk" v-for="itemRep in item.adminReplay">
                  <div class="vcdk_pic"><img src="/static/favicon.ico" /></div>
                  <div class="vcdk_info">
                    <div class="vcdki_user"><span class="vcdki_user_name">医博士官方人员<!--{{item.adminName}}--></span><span class="vcdki_user_time">{{itemRep.createTime}}</span></div>
                    <div class="vcpli_text">{{itemRep.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vc_plPage">
          <el-pagination
            small
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :total="total">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!--  -----------------------------------------------记录笔记-------------------------------------------------    -->
      <el-tab-pane label="记录笔记" name="second">



        <div class="vc_wypl">
          <div class="vcw_textarea"><textarea v-model="commentNoteValue" placeholder="我来说两句...(最多500字符)" maxlength="500"  id="TextArea2" @keyup="checkNoteLength();"></textarea></div>
          <div class="vcw_btn">
            <p class="vcw_btn_num">您还可以输入：<span id="sy">{{currNote}}</span>字</p>
            <el-tooltip content="请勿发表政治性言论，请勿谈论色情、暴力等内容的话题。严禁任何反动言论和宣传;" placement="top" effect="light">
              <el-button @click="commitCommentNote" type="primary" :disabled="!commentNoteValue">保存笔记</el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="vc_title">
          <div class="vct_text">全部笔记<span>（{{totalNote}}）</span></div>
        </div>
        <div class="vc_plList">
          <div class="vcpl" v-for="item in noteList">
            <div class="vcpl_info">
              <div class="vcpli_user">
                <span class="vcpli_user_time">{{item.createTime}}</span></div>
              <div class="vcpli_text">
                {{item.content}}
              </div>
            </div>
          </div>
        </div>
        <div class="vc_plPage">
          <el-pagination
            small
            layout="prev, pager, next"
            @current-change="handleNoteCurrentChange"
            :current-page.sync="currentPageNote"
            :page-size="pageSizeNote"
            :total="totalNote">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <loginLayer :visible.sync="loginVisible"></loginLayer>
  </div>
</template>

<script>
  import {listComment, saveComment,saveNote,listNotes} from '../api/api';
  import loginLayer from '../components/LoginLayer';
  import {mapGetters} from 'vuex'

  export default {
    components: {
      loginLayer
    },
    props: {
      typeId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        commentList: [],
        commentValue: '',
        pageSize:10,
        total:0,
        currentPage:1,
        loginVisible:false,
        maxChars:200,
        curr:200,
        activeName:'first',
        maxNoteChars:500,
        currNote:500,
        commentNoteValue: '',
        noteList: [],
        pageSizeNote:10,
        totalNote:0,
        currentPageNote:1,
    }
    },
    mounted() {
      this.init()
      this.initNotes()
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    methods: {
      checkLength() {
        if(this.commentValue.length > this.maxChars){
          alert("您出入的字数超多限制!");
          // 超过限制的字数了就将 文本框中的内容按规定的字数 截取
          this.commentValue = this.commentValue.substring(0,this.maxChars);
          document.getElementById("sy").innerHTML="";
          return false;
        }else{
          this.curr = this.maxChars - this.commentValue.length ; //200 减去 当前输入的
          return true;
        }
      },
      checkNoteLength() {
        if(this.commentNoteValue.length > this.maxNoteChars){
          alert("您出入的字数超多限制!");
          // 超过限制的字数了就将 文本框中的内容按规定的字数 截取
          this.commentNoteValue = this.commentNoteValue.substring(0,this.maxNoteChars);
          document.getElementById("sy").innerHTML="";
          return false;
        }else{
          this.currNote = this.maxNoteChars - this.commentNoteValue.length ; //200 减去 当前输入的
          return true;
        }
      },
      init() {
        listComment({
          typeId: this.typeId,
          pageNum: this.currentPage
        }).then((response) => {
          let {data} = response
          this.total = data.count
          this.commentList = data.list
        });
      },
      initNotes() {
        if(this.userInfo){
          listNotes(this.userInfo.id,
            {courseId: this.$route.query.cId,
            userId: this.userInfo.id,
            pageSize: this.pageSizeNote,
            pageNum: this.currentPageNote}
          ).then((response) => {
            let {data} = response
            this.totalNote = data.total
            this.noteList = data.list
          });
        }

      },
      commitComment() {
        if(this.userInfo){
          saveComment({
            typeId: this.typeId,
            userId: this.userInfo.id,
            content: this.commentValue
          }).then((response) => {
            let {data} = response
            if (data.status == 200) {
              this.$message.success(data.msg);
              this.commentValue = ''
              this.curr=200
              this.currentPage=1
              this.init();
            } else {
              this.$message.error(data.msg);
            }
          });
        }else{
          this.loginVisible=true
        }
      },
      commitCommentNote() {
        if(this.userInfo){
          saveNote({
            courseId: this.$route.query.cId,
            userId: this.userInfo.id,
            content: this.commentNoteValue
          }).then((response) => {
            let {data} = response
            if (data.code == 1) {
              this.$message.error(data.msg);
            } else {
              this.$message.success(data.msg);
              this.commentNoteValue = ''
              this.currNote=500
              this.currentPageNote=1
              this.initNotes();
            }
          });
        }else{
          this.loginVisible=true
        }
      },
      handleCurrentChange(currentPage){
        this.init()
      },
      handleNoteCurrentChange(currentPage){
        this.initNotes()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .video_comment {
    margin: 0px auto;
  }

  .vc_title {
    height: 40px;
    border-bottom: 1px #ddd solid;
    margin-top: 15px;
  }

  .vc_title .vct_text {
    border-bottom: 2px #1d7a8e solid;
    font-size: 16px;
    padding: 0px 12px;
    line-height: 38px;
    color: #1d7a8e;
    font-weight: bold;
    display: inline-block;
  }

  .vc_title .vct_text span {
    font-size: 12px;
    font-weight: normal;
    color: #888;
  }

  .vc_wypl {
    width: 95%;
    margin: 0px auto;
    border: 1px #ddd solid;
    border-radius: 6px;
    margin-top: 15px;
  }

  .vcw_textarea {
    border-bottom: 1px #ddd solid;
  }

  .vcw_textarea textarea {
    padding: 10px;
    width: 100%;
    height: 90px;
    border: 0px;
    background: none;
    font-size: 14px;
  }

  .vcw_btn {
    width: 100%;
    padding: 12px;
    text-align: right;
    border-top: 0px;
    position: relative;
  }
  .vcw_btn p.vcw_btn_num{display: block;color:#9a9a9a;width:200px; text-align: left;position: absolute;left:15px;top:10px; line-height: 20px; font-size: 14px;}
  .vcw_btn p.vcw_btn_num span{color:#ff5300; padding-right: 6px;}
  .vc_plList {
    width: 100%;
  }

  .vcpl {
    width: 100%;
    position: relative;
    padding: 10px 10px 10px 60px;
    border-bottom: 1px #ddd solid;
  }

  .vcpl .vcpl_pic {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 0;
    top: 10px;
  }

  .vcpl .vcpl_pic img {
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }

  .vcpl_info {
  }

  .vcpli_user {
    font-size: 14px;
    line-height: 25px;
    height: 25px;
    overflow: hidden;
  }
  .vcpli_text{font-size: 14px; line-height: 22px;}
  .vcpli_user .vcpli_user_name {
    color: #1d7a8e;
    padding-right: 30px;
  }

  .vcpli_user .vcpli_user_time {
    color: #9a9a9a;
    font-size: 12px;
    line-height: 24px;
    min-height: 25px;
  }

  .vc_plPage {
    min-height: 64px;
    padding: 20px;
    text-align: right;
  }

  .vcpli_disk{background:#f1f1f1; padding:0px 15px 15px 15px;}
  .vcdk{width:100%;position: relative; padding: 10px 20px 10px 42px;border-bottom: 1px #ddd solid;}
  .vcdk .vcdk_pic{width:32px;height: 32px; position: absolute;left:0;top:15px;}
  .vcdk .vcdk_pic img{width:32px; height:32px;border-radius: 16px;}
  .vcdk_info{ min-height:44px;}
  .vcdki_user{font-size: 14px;line-height: 25px; height: 25px; overflow: hidden;}
  .vcdki_user .vcdki_user_name{color:red; padding-right: 30px;}
  .vcdki_user .vcdki_user_time{color: #9a9a9a; font-size: 12px; line-height: 24px; min-height: 25px;}
</style>



// WEBPACK FOOTER //
// src/components/Comment.vue